module.exports = __webpack_public_path__ + "img/cusetomerImg2.f61d171b.png";